import React from 'react'
import { Box, ThemeProvider } from '@mui/material'
import './controlRoom.css'
import { Routes, Route } from 'react-router-dom'
import DomainSearch from './domainSearch'
import { controlRoomTheme } from './theme'
import LicenseControlRoom from './license'

function ControlRoomApp() {
  return (
    <ThemeProvider theme={controlRoomTheme}>
      <Routes>
        <Route path='/domain-search' element={<DomainSearch />} />
        <Route path='/license' element={<LicenseControlRoom />} />
      </Routes>
    </ThemeProvider>
  )
}

export default ControlRoomApp
